import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from 'src/services/auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MyparkingRedirectGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const loginPath = environment.isMyParkingDeployment ? '/login' : '/myparking/login';

    // If user is NOT authenticated, redirect to login
    if (!this.authService.isLoggedIn) {
      this.router.navigate([loginPath]);
      return false;
    }

    // If authenticated, allow access to dashboard
    return true;
  }
}
